export interface LoginCallbackPageProps {}
export const LoginCallbackPage = ({}: LoginCallbackPageProps) => {
    return <></>;
};
